<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>
      本地址仅作为后台接口，供小程序、app等调用，不提供前端页面。
    </p>
    <p>
      具体接口，请联系作者本人。
    </p>

    <p>
      2020年6月
    </p>

    <div class="footer">
      版权所有：谭越
      ICP备案号：<a href="http://www.beian.miit.gov.cn" target="_blank">京ICP备20023962号</a>
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802032270" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../assets/beian.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 11010802032270号</p></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

  .footer {
    width: 100%;
    position: fixed;
    text-align: center;
    bottom: 10px;
  }
</style>
